import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

export const FigmaSectionTitle = ({
  title,
  subtitle,
  href,
  linkLabel = 'View All',
  align = 'left',
}) => {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  const borderStyle = align === 'center' ? '' : 'border-l-4 border-blue-600 pl-3';

  return (
    <div className={`flex flex-col gap-2 ${alignment}`}>
      <div className={`flex items-center gap-3 ${borderStyle}`}>
        {align === 'center' && <span className="h-1.5 w-8 rounded-full bg-blue-600 mr-2" />}
        <h2 className="text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
          {title}
        </h2>
        {align === 'center' && <span className="h-1.5 w-8 rounded-full bg-blue-600 ml-2" />}
      </div>
      {subtitle ? (
        <p className="max-w-2xl text-sm text-slate-700 sm:text-[15px]">{subtitle}</p>
      ) : null}
      {href ? (
        <Link
          href={href}
          className="inline-flex items-center gap-1 text-sm font-semibold text-blue-700 transition-colors hover:text-blue-800"
        >
          {linkLabel}
          <ChevronRight className="h-4 w-4" />
        </Link>
      ) : null}
    </div>
  );
};
